import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import '../style/header.scss';
import '../style/snapfish.scss';
import {
	requestSnapfishSaveSelection,
	clearSelection,
	sendSelectionToSnapfish
} from '../../snapfish/actions/snapfish-actions';

class SnapfishHeader extends PureComponent {
	constructor(props) {
		super(props);

		this.sendSelection = this.sendSelection.bind(this);
		this.cancelSelection = this.cancelSelection.bind(this);
	}

	getComponentName() {
		return 'SnapfishHeader';
	}

	sendSelection() {
		const { selectedItems, sendSelection, removePicker, clearSelection } = this.props;
		sendSelection(selectedItems);
		clearSelection();
		removePicker();
	}

	cancelSelection() {
		const { removePicker, closeCallback, clearSelection } = this.props;
		clearSelection();
		removePicker();
		closeCallback();
	}





	render() {
		let showButton = this.props.selectedItems.length === 0;
		return (
			<header className="select-mode header-flex-container snapfish-select">
				<div className="header-flex-left">
					<div className="header-item header-item-left" onClick={this.cancelSelection}>
						<div className="header-icon cancel" />
						<span className="cancel-text">Cancel</span>
					</div>
					&nbsp;
					<div className="header-item header-label">
                        {this.props.selectedItems.length === 0 ? `Select Photos` : ''}
						{this.props.selectedItems.length > 0 ? `${this.props.selectedItems.length} Selected` : ''}

					</div>
				</div>
				{}
				<div className="header-flex-right">
					<div className="header-item header-item-right">

						<div className={showButton ? 'hidden' : 'header-label snapfish-header-button'} onClick={this.sendSelection}>
							<span className="desktop">Add Selected Photos &gt;</span>
							<span className="mobile">Add Photos &gt;</span>
						</div>
					</div>
				</div>
			</header>
		);
	}
}

SnapfishHeader.propTypes = {
	selectedItems: PropTypes.array,
	albumItems: PropTypes.object,
	saveSelection: PropTypes.func,
	sendSelection: PropTypes.func,
	successCallback: PropTypes.func,
	closeCallback: PropTypes.func,
	removePicker: PropTypes.func,
    photoElements: PropTypes.object,
    clearSelection: PropTypes.func
};

const mapStateToProps = state => {
	return {
		photoElements: state.snapfish.snapfishPhotoElements,
		selectedItems: [...state.snapfish.snapfishSelectedElements]
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		saveSelection: selectedItemArray => requestSnapfishSaveSelection(dispatch, selectedItemArray),
		clearSelection: () => dispatch(clearSelection()),
		sendSelection: selectedItemArray => dispatch(sendSelectionToSnapfish(ownProps.successCallback, selectedItemArray))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SnapfishHeader);



// WEBPACK FOOTER //
// ./src/header/components/snapfish-header.jsx